import Decimal from "decimal.js";

export function calculatePenalty(original, penaltyRate) {
  // use decimal.js to avoid floating point precision issues
  const dorg = new Decimal(original);
  const drate = new Decimal(penaltyRate);
  const result = dorg.times(drate).floor().toNumber();
  return result;
}
